import { render } from "./FiltersForm.vue?vue&type=template&id=6b1eeb3e"
import script from "./FiltersForm.vue?vue&type=script&lang=js"
export * from "./FiltersForm.vue?vue&type=script&lang=js"

import "./FiltersForm.vue?vue&type=style&index=0&id=6b1eeb3e&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__